<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar class="ion-padding">
    <ion-button class="ion-no-padding" slot="start" fill="clear" size="small" (click)="close()">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    <ion-title class="fs-18 font-medium">{{ 'pages.fund-cash.purchase.transferModal.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content mode="ios" class="ion-padding-2">
  <ng-container *ngIf="buyers$ | async as buyers; else loading">
    <ion-radio-group class="ion-margin-top w-full" [(ngModel)]="selectedBuyerId" *ngIf="buyers.length > 0">
      <ion-item class="ion-no-padding w-full" mode="md" *ngFor="let buyer of buyers">
        <ion-icon name="person" slot="start"></ion-icon>
        <ion-label class="font-regular">{{ buyer.name }}</ion-label>
        <ion-radio slot="end" [value]="buyer.id"></ion-radio>
      </ion-item>
    </ion-radio-group>
    <p *ngIf="buyers.length === 0" class="w-full ion-text-center font-regular">
      {{ 'pages.fund-cash.purchase.transferModal.empty' | translate }}
    </p>
  </ng-container>
  <ng-template #loading>
    <div class="w-full h-full flex ion-justify-content-center ion-align-items-center">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  </ng-template>
</ion-content>

<ion-footer class="ion-no-border ion-padding-2 text-center" mode="ios">
  <ion-button class="w-full" (click)="save()" [disabled]="!this.selectedBuyerId">
    {{ 'pages.fund-cash.purchase.transferModal.submit' | translate }}
  </ion-button>
</ion-footer>
